export default __webpack_public_path__ + "static/media/sad.5ece0416.svg";